import { ReactNode, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { ERole } from "../../../@types";
import { useAccount } from "../../../hooks/useAccount";

export type TRoleBaseGuardProps = {
	accessibleRoles: ERole[];
	children: ReactNode;
};

export function RoleBasedGuard({
	accessibleRoles,
	children,
}: TRoleBaseGuardProps) {
	const { account } = useAccount();
	const navigate = useNavigate();

	useEffect(() => {
		const checkAccount = async () => {
			if (
				accessibleRoles.includes(ERole.INSTRUCTOR) &&
				!accessibleRoles.includes(ERole.STUDENT) &&
				account?.role === ERole.STUDENT
			) {
				navigate("/become-instructor");
				return;
			}

			if (account?.role && !accessibleRoles.includes(account.role)) {
				navigate("/");
				return;
			}
		};

		checkAccount();
	}, [accessibleRoles, account?.role, navigate]);

	if (account?.role && !accessibleRoles.includes(account.role)) {
		return null;
	}

	return <>{children}</>;
}
